function mmToggleDescr() {
	let trunDescriptions = document.querySelectorAll(".mm-truncate-descr");
	trunDescriptions.forEach(function (descr) {
		descr.classList.toggle("mm-none");
	});
}

// Fonction pour gérer le bouton "Lire plus" en mobile
function initReadMore() {
    const mobileTexts = document.querySelectorAll('.mm-mobile .text-sm');
    
    mobileTexts.forEach(text => {
        // Vérifier si le texte dépasse 3 lignes
        const lineHeight = parseInt(window.getComputedStyle(text).lineHeight);
        const textHeight = text.scrollHeight;
        const maxHeight = lineHeight * 3;
        
        if (textHeight > maxHeight) {
            // Créer le bouton "Lire plus"
            const readMoreButton = document.createElement('span');
            readMoreButton.className = 'read-more-button visible titre-small';
            readMoreButton.textContent = 'LIRE PLUS';
            
            // Ajouter le bouton après le texte
            text.parentNode.insertBefore(readMoreButton, text.nextSibling);
            
            // Gérer le clic sur le bouton
            readMoreButton.addEventListener('click', () => {
                text.classList.toggle('expanded');
                readMoreButton.textContent = text.classList.contains('expanded') ? 'LIRE MOINS' : 'LIRE PLUS';
            });
        }
    });
}

// Initialiser au chargement de la page
document.addEventListener('DOMContentLoaded', initReadMore);
